import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "album-picker"
}
const _hoisted_2 = { class: "search" }
const _hoisted_3 = { class: "albums-container" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "actions" }
const _hoisted_6 = { class: "submit-btn-wrapper" }
const _hoisted_7 = {
  key: 0,
  class: "remove-notice"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XLoadingIcon = _resolveComponent("XLoadingIcon")!
  const _component_MagnifyIcon = _resolveComponent("MagnifyIcon")!
  const _component_NcTextField = _resolveComponent("NcTextField")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_AlbumsList = _resolveComponent("AlbumsList")!
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_NcButton = _resolveComponent("NcButton")!
  const _component_AlbumForm = _resolveComponent("AlbumForm")!

  return (!_ctx.showAlbumCreationForm)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.loadingAlbums)
          ? (_openBlock(), _createBlock(_component_XLoadingIcon, {
              key: 0,
              class: "loading-icon centered"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_NcTextField, {
            autofocus: false,
            modelValue: _ctx.search,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            label: _ctx.t('memories', 'Search'),
            placeholder: _ctx.t('memories', 'Search')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_MagnifyIcon, { size: 16 })
            ]),
            _: 1
          }, 8, ["modelValue", "label", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_AlbumsList, {
            ref: "albumsList",
            albums: _ctx.filteredList,
            link: false,
            onClick: _ctx.toggleAlbumSelection
          }, {
            extra: _withCtx(({ album }) => [
              _createElementVNode("div", {
                class: _normalizeClass({
              'album-selected': _ctx.selection.has(album),
              'check-circle-icon': true,
              'check-circle-icon--active': _ctx.selection.has(album),
            }),
                onClick: ($event: any) => (_ctx.toggleAlbumSelection(album))
              }, [
                _createVNode(_component_CheckIcon, { size: 20 })
              ], 10, _hoisted_4)
            ]),
            _: 1
          }, 8, ["albums", "onClick"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_NcButton, {
            "aria-label": _ctx.t('memories', 'Create new album.'),
            disabled: _ctx.disabled,
            class: "new-album-button",
            variant: "tertiary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAlbumCreationForm = true))
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_PlusIcon)
            ]),
            default: _withCtx(() => [
              _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'Create new album')), 1)
            ]),
            _: 1
          }, 8, ["aria-label", "disabled"]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_NcButton, {
              class: "new-album-button",
              variant: "primary",
              "aria-label": _ctx.t('memories', 'Save changes'),
              disabled: _ctx.disabled,
              onClick: _ctx.submit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('memories', 'Save changes')), 1)
              ]),
              _: 1
            }, 8, ["aria-label", "disabled", "onClick"]),
            (_ctx.deselection.size > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.n('memories', 'Removed from {n} album', 'Removed from {n} albums', _ctx.deselection.size, {
              n: _ctx.deselection.size,
            })), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : (_openBlock(), _createBlock(_component_AlbumForm, {
        key: 1,
        "display-back-button": true,
        title: _ctx.t('memories', 'New album'),
        onBack: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAlbumCreationForm = false)),
        onDone: _ctx.albumCreatedHandler
      }, null, 8, ["title", "onDone"]))
}